import type { JSX } from 'react';
import { Link, Tooltip } from '@mui/material';
import type { AgentVersionStatus } from '../../lib/agentVersion';

interface VersionLinkProps {
  status: AgentVersionStatus;
  onClick: () => void;
}

export function VersionLink({ status, onClick }: VersionLinkProps): JSX.Element {
  const color = (() => {
    if (status.currentVersion === null) return 'text.disabled';
    if (status.isAtLatest) return 'success.main';
    if (status.isOutdated && status.isBlocked) return 'error.main';
    if (status.isOutdated) return 'warning.main';
    return 'text.secondary';
  })();

  const tooltip = (() => {
    if (status.currentVersion === null) return 'Versiune necunoscută';
    if (status.isAtLatest) return 'Agent la zi cu ultima versiune';
    if (status.isOutdated && status.isBlocked) {
      return status.updateDisabled
        ? 'Învechit & auto-update DEZACTIVAT pe agent'
        : 'Învechit & canal îngheţat';
    }
    if (status.isOutdated) {
      return `Versiune nouă disponibilă: ${status.latestVersionOnChannel ?? '?'}`;
    }
    return 'Click pentru detalii update';
  })();

  return (
    <Tooltip title={tooltip}>
      <Link
        component="button"
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        sx={{
          color,
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: '0.95rem',
          fontWeight: 500,
          background: 'none',
          border: 'none',
          padding: 0,
        }}
      >
        (v{status.currentVersion ?? '?'})
      </Link>
    </Tooltip>
  );
}
